import BaseApiServiceV2 from "./BaseApiServiceV2";

class GoogleService extends BaseApiServiceV2 {
    getGoogleReviews(
        country = "Australia",
        limit = "10",
        page = "1",
        sortOrder = "desc",
    ) {
        return this.apiGet(
            `/google-reviews/${country}?limit=${limit}&page=${page}&sortOrder=${sortOrder}`,
        );
    }
    getTestimonials(
        country = "",
        page = 1,
        limit = 20,
        ratings = "",
        text = "",
        topic = "",
        sortOrder = "desc",
        type = "Office Hub",

    ) {
        return this.apiGet(
            `/google-reviews/reviews-by-filters/?country=${country}&page=${page}&limit=${limit}&ratings=${ratings}&topic=${topic}&textSearch=${text}&type=${type}&sortOrder=${sortOrder}`,
        );
    }
}
export default new GoogleService();
